import { useState } from 'react';
import { GA_EVENT_TOP_NAVIGATION_CLICK } from '@common/Tracking';
import { menuSelectItemListTracking } from '@common/Tracking/Navigation';
import { BEMBlock } from '@helpers/classnames';
import { parseJSON } from '@helpers/data';
import { pushGAEventToDataLayer } from '@helpers/dataLayer';
import { isNavConfigEnabled } from '@helpers/navigation';
import { NavigationItem } from '../components/NavigationItem';
import '../styles/SubHeader.scss';

function SubHeader({
    activeDropdownItem,
    hasMainHeaderDropdown,
    navTree,
    uuids,
    onSubHeaderNavBarHover,
    selectedDepartment,
    topMenuTree
}) {
    const [currentUuid, setCurrentUuid] = useState('');
    const [block, BEMElement] = BEMBlock('header-navigation');

    const handleClick = (event, category, subCategory) => {
        const topLevelMenuItem = topMenuTree.find(menuItem => (
            menuItem.navigationId === selectedDepartment.id
        ));
        const navItemLvl = !isNavConfigEnabled(topLevelMenuItem, 'desktopNavigationDropdownHide')
            ? 3
            : 2;
        const trackingNavItem = {
            lvl: navItemLvl, navigationId: subCategory.navigationId, type: subCategory.type, url: subCategory.url
        };
        menuSelectItemListTracking(trackingNavItem, selectedDepartment);
        pushGAEventToDataLayer(GA_EVENT_TOP_NAVIGATION_CLICK, category.name, subCategory.name);
        setCurrentUuid(category.uuid);
    };

    const handleMenuItemFocus = (navItem) => {
        onSubHeaderNavBarHover?.(navItem);
    };

    const handleMenuItemHover = (navItem) => {
        onSubHeaderNavBarHover?.(navItem);
    };

    return (
        <div className={block}>
            <div className={BEMElement('menu')}>
                {
                    navTree.children.map((navItem, index) => (
                        <NavigationItem
                            key={navItem.navigationId}
                            activeDropdownItem={activeDropdownItem}
                            hasMainHeaderDropdown={hasMainHeaderDropdown}
                            index={index}
                            isActive={navItem.uuid === currentUuid || parseJSON(uuids).includes(navItem.uuid)}
                            navItem={navItem}
                            navTree={navTree}
                            onClick={handleClick}
                            onFocus={handleMenuItemFocus}
                            onHover={handleMenuItemHover}
                        />
                    ))
                }
            </div>
        </div>
    );
}

export default SubHeader;
